import { Player } from "@lottiefiles/react-lottie-player";
import { useRef } from "react";
import styled from "styled-components";

const AnimatedScroll = () => {


    return (
        <StyledIcon> <Player
            autoplay
            loop
            className="ani"
            src="lottie/scroll-up.json"
            style={{
                position: "absolute",
                height: "35px",
                width: "65px",
                zIndex: 9999,
                transform: "rotate(90deg)",
                left: "-33px",
                bottom: "-17px"
            }}
        ></Player></StyledIcon>

    );
};

export default AnimatedScroll;

const StyledIcon = styled.div`
.ani svg > g > g:last-child{
    display: none !important;
}
`;